import React from 'react';
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs';
import SceneTopBar, { SceneTopBarProps } from './scene-top-bar';
import SceneContent, { SceneContentProps } from './scene-content';
import SceneTabs, { SceneTabsProps } from './scene-tabs';
import SceneBottomBar from './scene-bottom-bar';

interface Props
  extends SceneTopBarProps,
    SceneContentProps,
    Omit<SceneTabsProps, 'tabs' | 'selectedTab' | 'onSelectedTab'> {
  tabs?: string[];
  selectedTab?: number;
  onSelectedTab?: (selectedTab: number) => void;
}

function ScenePage({ children, title, tabs, selectedTab, onSelectedTab, breadCrumps }: Props) {
  const breadCrumpsDefault = useBreadcrumbs();

  return (
    <>
      <SceneTopBar title={title} breadCrumps={breadCrumps || breadCrumpsDefault} />
      {tabs && onSelectedTab && selectedTab !== undefined && (
        <SceneTabs tabs={tabs} selectedTab={selectedTab} onSelectedTab={onSelectedTab} />
      )}
      <SceneContent withTabsInside={!!tabs}>{children}</SceneContent>
      <SceneBottomBar />
    </>
  );
}

export default ScenePage;
